export default function tileZXYToLatLonBBox(zoomLevel, x, y) {

    let lonMin = (x / Math.pow(2, zoomLevel)) * 360 - 180; 
    let lonMax = ((x + 1) / Math.pow(2, zoomLevel)) * 360 - 180;
    
    const n1 = Math.PI - (2 * Math.PI * y) / Math.pow(2, zoomLevel);
    const latMax = (180 / Math.PI) * Math.atan(Math.sinh(n1));

    const n2 = Math.PI - (2 * Math.PI * (y + 1)) / Math.pow(2, zoomLevel);
    const latMin = (180 / Math.PI) * Math.atan(Math.sinh(n2));
    
        return [
        [lonMin, latMax],
        [lonMax, latMax],
        [lonMax, latMin],
        [lonMin, latMin]
    ]
}